const O2O_BANNER = 'offline_to_online_banner';

export const WEBSITE_MATCH_LINK = `/match/website/business-purposes?source=${O2O_BANNER}`;

export const VIDEO_CONFIG = {
    id: 'Website_Match',
    name: 'Website Match',
    src: 'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd_nl/dh7gbacmba9vyeamscxf'
};

export const BI_CONSTS = {
    FEATURE_NAME: 'offline_to_online',
    PAGE_NAME: 'listings_page'
};

export const BI_EVENTS = {
    BANNER_IS_SHOWN: 'offline_to_online_banner_is_shown',
    WATCH_VIDEO_CLICKED: 'clicked_on_watch_video_on_offline_to_online_banner',
    CREATE_WEBSITE_CLICKED: 'clicked_on_create_a_website_on_offline_to_online_banner'
};
